import React from 'react';

import { TableCell } from '@mui/material';
import { useTranslation } from 'react-i18next';

import TableTotalFooter from '../../../../components/TableTotalFooter';
import { NumberHelper } from '../../../../helpers/number.helper';
import { IStaffStatusEvolution } from '../../../../types/staff-status-evolution.type';
import { ArrayUtils } from '../../../../utils/array.utils';

interface IProps {
  evolution: IStaffStatusEvolution[];
}

const StaffStatusEvolutionListFooter = React.memo(({ evolution }: IProps) => {
  const { t } = useTranslation();

  const totalPeriod1 = ArrayUtils.calculateTotal(evolution, 'quantityPeriod1');
  const totalPeriod2 = ArrayUtils.calculateTotal(evolution, 'quantityPeriod2');

  return (
    <TableTotalFooter textAlign="center">
      <TableCell sx={{ fontWeight: 'bold' }}>{t(`general.total`)}</TableCell>
      <TableCell>{totalPeriod1}</TableCell>
      <TableCell>{totalPeriod2}</TableCell>

      <TableCell>
        {Math.round(NumberHelper.calculateSimplePercentage(totalPeriod1, totalPeriod2))}%
      </TableCell>
    </TableTotalFooter>
  );
});

export default StaffStatusEvolutionListFooter;
